package diana.soleil.design.iraniancanadienbazzar.core.model

/**
 * How the app resolves light vs dark. Persisted device-locally (see `AppPreferences.appearanceCode`)
 * and applied at the theme root by `AppTheme`.
 *
 * [System] follows the OS setting; [Light] and [Dark] pin it. Default is [System] — the OS setting is
 * the user's already-expressed preference, and honouring it is what users assume in 2026.
 */
enum class AppearanceMode(val code: String) {
    System("system"),
    Light("light"),
    Dark("dark"),
    ;

    companion object {
        /** Lenient parse for the persisted value; anything unrecognized falls back to [System]. */
        fun fromCode(code: String?): AppearanceMode =
            entries.firstOrNull { it.code.equals(code?.trim(), ignoreCase = true) } ?: System
    }
}
